// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { real as _real } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the real chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 111188
 * Chain Name: re.al
 * Default Block Explorer: https://explorer.re.al
 * Default RPC URL: https://real.drpc.org
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { real } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: real,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const real = createCommon({
	..._real,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
